/** @type {import("../types/mutations/app").AppMutationKeys} */
const app_mutation_keys = { 
    "SET_LOADING_STATUS": "APP/SET_LOADING_STATUS"
}

/** @type {import("../types/mutations/app").AppMutations} */
const app_mutations = {
    [app_mutation_keys.SET_LOADING_STATUS]: (state, loading) => state.loadingApplication = loading
}

export default app_mutations;

export { app_mutation_keys }